module.exports = __webpack_public_path__ + "static/media/AroundYouBG.163f1249.jpg";